module.exports = __webpack_public_path__ + "img/PAI_Landing-Page_Mobile_12.3672db4c.jpg";